import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../shared/base-api-template-service.model';
import { Core2Config } from '../shared/core2Config';
import { PostViewContainerModel } from '../../../../../models/aggregates/post-view';
import { CmsPostContainerModel } from '../../../../../models/aggregates/erp/cms-post';
import { Observable } from 'rxjs';
import { BasicApiResponseModel } from '../shared/api-response.model';
import { ApiVisa } from '../shared';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';
import { cookieObject } from '../../../../../models/dbschema/bl_cms_post_view_hdr.model';

@Injectable({
  providedIn: 'root'
})
export class PostViewService extends BaseApiPublicLoginTemplateService<PostViewContainerModel,PostViewContainerModel,PostViewContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/' + BaseApiTemplateService.LOGIN_ENTITY_EP;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/' + BaseApiTemplateService.PUBLIC_EP;
    this.httpClient = http;
  }

  getUserCookieBackoffice(cookieUrl: string, visa: ApiVisa): Observable<Array<cookieObject>>{
    const backofficeUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'cookies/get-by-url/' + BaseApiTemplateService.BACKOFFICE_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'cookies/get-by-url/' + BaseApiTemplateService.BACKOFFICE_EP

    const url = backofficeUrl + `?url=${cookieUrl}`

    return this.httpClient.get<Array<cookieObject>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  getUserCookiePublic(cookieUrl: string, visa: ApiVisa): Observable<Array<cookieObject>>{
    const publicUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'cookies/get-by-url/' + BaseApiTemplateService.PUBLIC_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX  + 'cookies/get-by-url/' + BaseApiTemplateService.PUBLIC_EP

    const url = publicUrl + `?url=${cookieUrl}`

    return this.httpClient.get<Array<cookieObject>>(
      url,
      this.getHttpHeader(visa)
    );
  }
  
  getPostWithIncrementedViewCountBackoffice(postHdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<CmsPostContainerModel>>{
    const backofficeUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/update-view-count/'+ postHdrGuid + '/' + BaseApiTemplateService.BACKOFFICE_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/update-view-count/'+ postHdrGuid + '/' + BaseApiTemplateService.BACKOFFICE_EP
    return this.httpClient.get<BasicApiResponseModel<CmsPostContainerModel>>(
      backofficeUrl,
      this.getHttpHeader(visa)
    );
  }

  getPostWithIncrementedViewCountPublic(postHdrGuid: string, visa: ApiVisa): Observable<BasicApiResponseModel<CmsPostContainerModel>>{
    const publicUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/update-view-count/'+ postHdrGuid + '/' + BaseApiTemplateService.PUBLIC_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/update-view-count/'+ postHdrGuid + '/' + BaseApiTemplateService.PUBLIC_EP
    return this.httpClient.get<BasicApiResponseModel<CmsPostContainerModel>>(
      publicUrl,
      this.getHttpHeader(visa)
    );
  }

  getPostWithIncrementedViewCountUpsertPublic(postHdrGuid: string, cookieValue: string,  visa: ApiVisa): Observable<BasicApiResponseModel<CmsPostContainerModel>>{
    const publicUrl = visa.api_domain_url ?
    visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/upsert-view/'+ postHdrGuid + '/' + cookieValue + '/' + BaseApiTemplateService.PUBLIC_EP
    : Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'posts-view-hdr/upsert-view/'+ postHdrGuid + '/' + cookieValue + '/' + BaseApiTemplateService.PUBLIC_EP
    return this.httpClient.get<BasicApiResponseModel<CmsPostContainerModel>>(
      publicUrl,
      this.getHttpHeader(visa)
    );
  }

  postCookieValuePublic(dtoObject: PostViewContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<PostViewContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_public_url;
    }
    return this.httpClient.post<BasicApiResponseModel<PostViewContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}